import { render } from "./TestResults.vue?vue&type=template&id=4804d3fe"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__